import { CLEAR_NOTIFICATIONS } from "constants-lib/actionTypes"

export const clearNotifications = () => ({
  type: CLEAR_NOTIFICATIONS,
})
